export class PaymentModel {
    id?:number = undefined
    idSource?:number = undefined
    name:string = ''
    isActive:boolean = false

    constructor(p?: Partial<PaymentModel>) {
        Object.assign(this, p)
    }
}
